import { Link, Outlet, useParams } from "react-router-dom";

export default function CustomerLayout() {
  const { lang = "en" } = useParams();
  const links = ["profile", "addresses", "orders", "messages", "tickets", "wishlist", "returns"];
  return (
    <div className="container-page grid gap-6 py-8 md:grid-cols-[220px_1fr]">
      <aside className="panel p-4">
        <h2 className="mb-3 font-bold">Account</h2>
        {links.map((link) => <Link key={link} className="admin-link capitalize" to={`/${lang}/account/${link}`}>{link}</Link>)}
      </aside>
      <section className="panel p-5"><Outlet /></section>
    </div>
  );
}
